export const URL_POST_SIGN_UP = `${import.meta.env.VITE_API_URL}/auth/sign-up`
export const URL_POST_SIGN_IN = `${import.meta.env.VITE_API_URL}/auth/sign-in`
export const URL_POST_SEND_AUTH_CODE = `${import.meta.env.VITE_API_URL}/auth/send-auth-code`
export const URL_POST_SIGN_OUT = `${import.meta.env.VITE_API_URL}/auth/sign-out`
export const URL_GET_EXPORT_OBSERVATIONS = `${import.meta.env.VITE_API_URL}/reports/observations`
export const URL_GET_EXPORT_PLAN = `${import.meta.env.VITE_API_URL}/reports/plans`
export const URL_GET_EXPORT_FORMS = `${import.meta.env.VITE_API_URL}/reports/form`

export const BASE_URL = `${import.meta.env.BASE_URL}`
